module.exports = __webpack_public_path__ + "static/media/dropdown-homepage.fe978524.svg";